import '../styles/ModalRelease.css';
import { useTranslation } from 'react-i18next';
function ModalRelease({showModal, setShowModal}) {
    const { t } = useTranslation();
    function onClose() {
        setShowModal(!showModal)
    }

	return (
		<div className="modal-overlay">
            <div className="modal">
                <h1>{t('modalReleases.title')}</h1>
                <div className="modal-container">
                    <div className='modal-rev'>
                        <h2>15/08/2026</h2>
                        <h3>History</h3>
                        <ul>
                            <li>History added for all games, with all past puzzles</li>
                        </ul>
                        <h3>Library</h3>
                        <ul>
                            <li>Library added for all games, with all characters, items and swords</li>
                        </ul>
                    </div>
                    <div className='modal-rev'>
                        <h2>12/07/2026</h2>
                        <h3>Game Mode</h3>
                        <ul>
                            <li>The Legend of Zelda : Tears of the Kingdom added</li>
                        </ul>
                    </div>
                    <div className='modal-rev'>
                        <h2>12/06/2026</h2>
                        <h3>Game Mode</h3>
                        <ul>
                            <li>The Legend of Zelda : Ocarina of Time Remake added</li>
                        </ul>
                    </div>
                    <div className='modal-rev'>
                        <h2>12/05/2026</h2>
                        <h3>Item Mode</h3>
                        <ul>
                            <li>Items from The Legend of Zelda : A link to the past added</li>
                        </ul>
                        <h3>Game Mode</h3>
                        <ul>
                            <li>The Legend of Zelda : Echoes of Wisdom added</li>
                        </ul>
                        
                        <h3>Character Mode</h3>
                        <p>Mode "Character" added</p>
                        
                        <h3>Sword Mode</h3>
                        <p>Mode "Sword" added</p>
                    </div>
                    <div className='modal-rev'>
                        <h2>12/04/2025</h2>
                        <h3>Game Mode</h3>
                        <h3>Item Mode</h3>
                        <ul>
                            <li>Items from The Legend of Zelda : A link to the past added</li>
                        </ul>
                        <h3>Game Mode</h3>
                        <ul>
                            <li>The Legend of Zelda : Echoes of Wisdom added</li>
                        </ul>
                        
                        <h3>Character Mode</h3>
                        <p>Mode "Character" added</p>
                        
                        <h3>Sword Mode</h3>
                        <p>Mode "Sword" added</p>
                    </div>

                    <hr /> 

                    <div className='modal-rev'>
                        <h2>24/07/2024</h2>
                        <h3>Game Mode</h3>
                        <p>Mode "Game" added</p>
                        Catégories : 
                        <ul>
                            <li>Sales (Milions) : <a href='https://vgsales.fandom.com/wiki/The_Legend_of_Zelda' target='_blank' rel='noreferrer'>VGSALES</a></li>
                            <li>Notes : <a href='https://www.metacritic.com/' target='_blank' rel='noreferrer'>Metacritic</a></li>
                            <li>Type : Principal, Hors série, Remake</li> 
                        </ul>
                    </div>

                    <hr /> 

                    <div className='modal-rev'>
                        <h2>15/07/2024</h2>
                        <h3>Item Mode</h3>
                        Games includes :
                        <p>
                            <ul>
                                <li>Ocarina of Time (OOT)</li>
                            </ul>
                        </p>
                    </div>
                    <img src='/images/assets/close.png' alt='close' className="close-button" onClick={onClose} />
                </div>
            </div>
        </div>
	)
}

export default ModalRelease
